// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__26Agq","col":"CardReaderDesc_col__3jlDt","label":"CardReaderDesc_label__2k96h"};